module.exports = "/assets/d809c8b8cbfa148f3c1196f13c4cb434.svg";